import { render, staticRenderFns } from "./GenealogyTree.vue?vue&type=template&id=868a9ace&scoped=true"
import script from "./GenealogyTree.vue?vue&type=script&lang=js"
export * from "./GenealogyTree.vue?vue&type=script&lang=js"
import style0 from "./GenealogyTree.vue?vue&type=style&index=0&id=868a9ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868a9ace",
  null
  
)

export default component.exports